module.exports = __webpack_public_path__ + "img/jfdh.6c495e06.png";